// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import moment from 'moment'
import PrimeVue from 'primevue/config';
import 'primeflex/primeflex.min.css';
import 'primevue/resources/themes/saga-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import VueMeta from 'vue-meta';
Vue.use(VueMeta);

import App from './App'
import { db, auth } from './firebase/db'
import store from './store'
import router from './router'

import ConfirmationService from 'primevue/confirmationservice';
Vue.use(ConfirmationService);

/* prime vue globals */
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';

import ToastService from 'primevue/toastservice';
Vue.use(ToastService, {
  life: 3000,
  severity: 'success'
});

Vue.component('Button', Button)
Vue.component('InputText', InputText)

import Tooltip from 'primevue/tooltip';

Vue.directive('tooltip', Tooltip);

Vue.use(PrimeVue,{
  locale: {
    firstDayOfWeek: 1,
    dayNames: ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"],
    dayNamesShort: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
    dayNamesMin: ["Sø","Ma","Ti","On","To","Fr","Lø"],
    monthNames: [ "Januar","Februar","Mars","April","Mai","Juni","July","August","September","Oktober","November","Desember" ],
    monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "Mai", "Jun","Jul", "Aug", "Sep", "Okt", "Nov", "Des" ],
    today: 'I dag',
    clear: 'Tøm',
    dateFormat: 'dd/mm/yy',
    weekHeader: 'Uke',
    accept: 'Ja',
    reject: 'Nei'
  
  }
});

Vue.prototype.$db = db

Vue.config.productionTip = false
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment.unix(String(value)).format('DD/MM/YYYY')
  }
})

moment.locale('nb');

Vue.prototype.$moment = moment

import 'typeface-roboto/index.css';


import { onLogin } from '@/store/onLogin'




auth.onAuthStateChanged(res => {
  if(res !== null){
    onLogin({email: res.email, store}).then((data) => {
      if(!data){
        auth.signOut().then(() => {
          router.push({path: '/login', query: {hasPremissions: false}})
        })
      }
      if(store.getters["user/level"] == 0){
        auth.signOut().then(() => {
          router.push({path: '/login', query: {hasPremissions: false}})
        })
        
      }
      new Vue({
        render: h => h(App),
        router, 
        store,
      }).$mount('#app');
    })
  }
  else{
    new Vue({
      render: h => h(App),
      router, 
      store,
    }).$mount('#app');
  }
})